import { DateTime } from 'luxon';

import * as Yup from 'yup';

import RequestItems from './Components/RequestItems';
import { Component } from 'react';

const mockRows = [
  {
    _id: 1,
    name: 'item 1',
    price: 100,
    quantity: 10
  },
  {
    _id: 2,
    name: 'item 2',
    price: 200,
    quantity: 20
  },
  {
    _id: 3,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 4,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 5,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 6,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 7,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 8,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 9,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 10,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 11,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 12,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
  {
    _id: 13,
    name: 'item 3',
    price: 300,
    quantity: 30
  },
];

const headers = [
  {
    label: 'Request Num',
    id: 'request_num'
  },
  {
    label: 'Vendor',
    id: 'vendor'
  },
  {
    label: 'Item Qty',
    id: 'item_qty'
  },
  {
    label: 'Total Qty',
    id: 'total_qty'
  },
  {
    label: "Status",
    id: "status",
    multi: true,
    values: [{value: "unfulfilled", status: "error"}, {value: "partially fulfilled", status: "warning"}, {value: "fulfilled", status: "success"}]
  },
  {
    label: 'Date',
    date: true,
    id: 'date_created'
  }
];

const filters = [
  {
    id: "date_created",
    type: "date",
    label: "Date Created",
  }
]

const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "request_num",
    label: "Request Number (Optional)",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "formField",
    formFieldType: "date",
    name: "date_created",
    label: "Date",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "debounceSearch",
    formFieldType: "select",
    select: [],
    name: "vendor_id",
    label: "Search Vendor",
    url: "vendors",
    fieldName: "vendor_id",
    displayField: "full_name",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "divider",
    header: "Request Items",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <RequestItems />,
    size: {xs: 12, lg: 12},
  }
]

const initialValues = {
  request_num: '',
  vendor_id: '',
  date_created: DateTime.local(),
}

const additionalState = {
  items: [],
}

const schema = Yup.object().shape({
  
});

export { mockRows, filters, headers, fields, initialValues, schema, additionalState };
